import { Typography } from "@mui/material";
import styled from "styled-components";

export const colors = {
  success: "#4caf50",
  warning: "#ff9800",
  error: "#d32f2f",
  info: "#2196f3",
  lightSuccess: "#9feb9f3d",
  lightError: "rgba(235, 159, 159, 0.24)",
  publicisBlue: " #1048DD",
  publicisSeaBlue: "#27A9AF",
  text: "#4D4D4F",
  publicisSlateBlue: "#6B46C1",
  hoverBlue: "#1048dd12",
  theme: "#fafafa",
  grey: "#C2C2C2",
  secondaryBlue: "#6B46C1",
  growthOSLightBlue: "#97beff",
  growthOSLightDarkBlue: "#5a8bf2",
  growthOSDarkBlue: "#0234ad",
};

export const HeadingEighteen = styled(Typography)`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 27px;
  overflow-wrap: break-word;
`;

export const ActiveTextEighteen = styled(Typography)`
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  overflow-wrap: break-word;
`;

export const TextFourteenBlack = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  mix-blend-mode: normal;
  opacity: 0.4;
  overflow-wrap: break-word;
`;

export const TextFifteenYellow = styled(Typography)`
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  overflow-wrap: break-word;
`;

export const TextDelete = styled(Typography)`
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: #ff0000;
  overflow-wrap: break-word;
`;

export const NoListTypography = styled(Typography)`
  font-weight: 500;
  font-size: 30px;
  display: flex;
  justify-content: center;
  overflow-wrap: break-word;
`;
